/** 서버 오류 본문 → 타입 있는 오류. FE 는 status 가 아니라 code 로 카피를 고른다. */
import { z } from 'zod';

import {
  QUESTION_CARD_AI_ERROR_CODES,
  type QuestionCardAiErrorCode,
} from '../consts/questionCardAi.const';

export class QuestionCardAiHttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly code?: QuestionCardAiErrorCode,
    public readonly reason?: string,
  ) {
    super(code ?? `HTTP_${status}`);
    this.name = 'QuestionCardAiHttpError';
  }
}

export const isQuestionCardAiHttpError = (
  value: unknown,
): value is QuestionCardAiHttpError => value instanceof QuestionCardAiHttpError;

/**
 * 도메인 거절은 `{ detail: { code, message } }`, 인증·플랜 거절(데코레이터)은
 * `{ message }` 로 온다 — 후자는 code 가 없다. 모르는 code·모양이 다른 필드는 버리고
 * 읽을 수 있는 것만 남긴다(오류 본문 해석 실패가 오류 처리를 막지 않게).
 */
const ErrorBodySchema = z
  .object({
    detail: z
      .object({
        code: z.enum(QUESTION_CARD_AI_ERROR_CODES).optional().catch(undefined),
        message: z.string().optional().catch(undefined),
      })
      .optional()
      .catch(undefined),
    message: z.string().optional().catch(undefined),
  })
  .catch({});

export const toQuestionCardAiHttpError = async (
  response: Response,
): Promise<QuestionCardAiHttpError> => {
  const body = ErrorBodySchema.parse(
    await response.json().catch(() => undefined),
  );
  return new QuestionCardAiHttpError(
    response.status,
    body.detail?.code,
    body.detail?.message ?? body.message,
  );
};
